export default __webpack_public_path__ + "static/media/almanews_logo.dba689fb.svg";